import React from 'react'
import { useActions, useValues } from 'kea'
import { useSelector } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'

import I18n from 'lib/i18n'
import offlineToggleModeLogic from 'lib/components/offline-toggle-mode/logic'
import railsContext from 'lib/selectors/rails-context'
import OfflineToggleMode from 'lib/components/offline-toggle-mode'
import SubmitButton from 'lib/tags/submit-button'

import RequestSummary from './summary'
import PersonalNote from './personal-note'
import FullName from './full-name'
import Email from './email'
import Phone from './phone'

import sceneLogic from '~/scenes/pages/request/logic'

const Request = () => {
  const { restart, submitRequest } = useActions(sceneLogic)
  const { isValid, isSubmitting } = useValues(sceneLogic)
  const { offlineToggleMode } = useValues(offlineToggleModeLogic)
  const { currentUserId } = useSelector(railsContext)

  const handleRestart = event => {
    event.preventDefault()
    restart()
  }

  const handleSubmit = () => {
    submitRequest()
  }

  return (
    <div className='contact-form'>
      <h1 className='mb-20'>{I18n.t('react.request.request.title')}</h1>
      <p>{I18n.t('react.request.request.subtitle')}</p>
      <RequestSummary />
      <PersonalNote />
      {(!currentUserId || offlineToggleMode) && (
        <>
          <FullName />
          <Email />
          <Phone />
          <div className='terms'>
            {ReactHtmlParser(
              I18n.t('devise.registrations.new.terms_line', {
                terms_link: `<a href='/terms' title={} target='_blank'>${I18n.t(
                  'devise.registrations.new.terms_link'
                )}</a>`
              })
            )}
          </div>
        </>
      )}
      <div className='submit-part'>
        <div>
          <SubmitButton isSubmitting={isSubmitting} isButtonHaveDisabledStyle={!isValid} onClick={handleSubmit}>
            {I18n.t('react.request.request.submit')}
          </SubmitButton>
        </div>
        <div>
          <a href='#' title='restart the whole process' onClick={handleRestart}>
            {I18n.t('react.request.request.restart')}
          </a>
        </div>
      </div>
      <OfflineToggleMode />
    </div>
  )
}

export default Request
